import React from 'react';
import PropTypes from 'prop-types';
import classes from './SmallParagraph.module.scss';

const SmallParagraph = ({ className, children }) => {
  const pClass = `${classes.smallParagraph} ${className}`;
  return <p className={pClass}>{children}</p>;
};

SmallParagraph.propTypes = {
  className: PropTypes.string,
  children: PropTypes.string.isRequired,
};

SmallParagraph.defaultProps = {
  className: '',
};

export default SmallParagraph;
